/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  changeDataNotification,
  changeDataProfile,
  changeQbNewMessage,
  changeQbSession,
  changeQbUnread,
  changeLoading,
  changeMode,
} from '../../store';
import { useState, useEffect } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { getCookie, clearCookie } from '../../helper/lib';
import { getNotificationTop, getProfile, logout } from '../../services';
import { toast } from 'react-toastify';
import { onMessageListener } from '../../helper/firebase';
import QB from 'quickblox/quickblox';
import VendorMenu from '../Menu/VendorMenu';
import DesignerMenu from '../Menu/DesignerMenu';
import Logo from '../../assets/img/logo_kisahruang.png';
import CloseIcon from '../../assets/img/custom/close.svg';
import AppMobileMenu from '../AppMobileMenu';
import AppHeader from '../AppHeader';
import AppSidebar from '../AppSidebar';
import ScrollToTop from '../ScrollToTop';
import '../../styles/layout.css';

const Layout = () => {
  const tokenValue = getCookie('token');
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    dataNotification,
    dataProfile,
    loadingGeneral,
    qbNewMessage,
    qbSession,
    qbUnread,
    mode,
  } = useSelector((state) => state.global);
  const locationPathOne = location.pathname.split('/')[1];

  const [isLogged, setIslogged] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(true);
  const [currentPageType, setCurrentPageType] = useState(locationPathOne);

  const clearCache = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().then((success) => {
            if (success) {
              console.log('Service Worker unregistered successfully.');
            }
          });
        });
      });
    }

    window.indexedDB.deleteDatabase('firebase-heartbeat-database');
    window.indexedDB.deleteDatabase('firebase-installations-database');
    window.indexedDB.deleteDatabase('firebase-messaging-database');
    localStorage.clear();
    clearCookie('token');

    dispatch(changeQbNewMessage(null));
    dispatch(changeDataNotification(null));
    dispatch(changeDataProfile(null));
    dispatch(changeQbSession(null));
    dispatch(changeQbUnread(null));
    dispatch(changeLoading(false));
    dispatch(changeMode(null));

    setIslogged(false);
    navigate('/');
    //window.location.href = '/';
  };

  const getNotificationList = async () => {
    try {
      const response = await getNotificationTop(mode === 'designer' ? 2 : 1, 0);
      if (response.message === 'Success') {
        dispatch(changeDataNotification(response));
        return true;
      }
    } catch (error) {
      console.log(
        'error:',
        error?.response?.data?.message ?? 'Something went wrong'
      );
      if (error?.response?.data?.message === 'Unauthorized access') {
        clearCache();
      }
      return true;
    }
  };

  const getUserData = async () => {
    try {
      const response = await getProfile();

      if (response.message === 'Success') {
        dispatch(changeDataProfile(response.data));
        return true;
      }
    } catch (error) {
      console.log(
        'error:',
        error?.response?.data?.message ?? 'Something went wrong'
      );
      if (error?.response?.data?.message === 'Unauthorized access') {
        setIslogged(false);
        clearCache();
        return false;
      }
    }
  };

  const handleLogout = async () => {
    try {
      const response = await logout();
      if (response.message === 'Success') {
        clearCache();
      }
    } catch (e) {
      toast.error('Failed to logout');
    }
  };

  const conectChatting = async () => {
    let session = QB.service.getSession();
    let userId = session.user_id;
    let password = session.token;
    let params = { userId, password };

    QB.chat.connect(params, function (error, contactList) {
      // Event when get message
      QB.chat.onMessageListener = function (userId, message) {
        console.log('new messages:', userId, message);
        dispatch(
          changeQbNewMessage({
            sender_id: userId,
            message: message?.body,
            date_sent: parseInt(message?.extension?.date_sent),
            attachments: message?.extension?.attachments ?? [],
          })
        );
      };

      // Event when message on sent
      QB.chat.onSentMessageCallback = function (messageLost, messageSent) {};

      // Event when message on delivered
      QB.chat.onDeliveredStatusListener = function (
        messageId,
        dialogId,
        userId
      ) {};
    });
  };

  const fetchDialogs = async () => {
    let params = {
      created_at: {
        lt: Date.now() / 1000,
      },
      sort_desc: 'last_message_date_sent',
      limit: 10,
    };

    QB.chat.dialog.list(params, function (error, dialogs) {
      // Sukses Get List dialog
      if (error === null) {
        console.log('DIALOGS:', dialogs);
        let unread = 0;
        if (dialogs?.items?.length) {
          for (let i = 0; i < dialogs.items.length; ++i) {
            if (dialogs.items[i].unread_messages_count) {
              unread += dialogs.items[i].unread_messages_count;
            }
          }
        }
        dispatch(changeQbUnread(unread));
        console.log('unread:', unread);
      }
    });
  };

  const checkTokenExpired = async () => {
    try {
      const response = await getProfile();
      if (response.message === 'Success') {
        return true;
      }
    } catch (error) {
      if (error?.response?.data?.message === 'Unauthorized access') {
        return false;
      }
    }
  };

  const changeCurrentPageType = (p) => {
    setCurrentPageType(p);
    dispatch(changeMode(p === 'designer' ? 'designer' : 'vendor'));
  };

  const _navigateToDetail = (orderNo, id) => {
    if (mode === 'designer') {
      if (orderNo) {
        navigate(`/project/view/${orderNo}`);
      }
    } else {
      if (orderNo && id) {
        let slug = orderNo.replace(/\//g, '-') + '-' + id;
        navigate(`/orders/detail/${slug}/`);
      }
    }
  };

  const handleClickNotifItem = (item) => {
    _navigateToDetail(item.order_number, item.order_id);
  };

  const initialize = async () => {
    dispatch(changeLoading(true));
    if (tokenValue) {
      if (checkTokenExpired) {
        const notification = await getNotificationList();
        const loadUser = await getUserData();

        if (notification && loadUser) {
          dispatch(changeLoading(false));
          setIslogged(true);
          return;
        }
      }
      clearCache();
      return;
    }

    clearCache();
  };

  const menu = () => {
    return mode !== 'designer' ? (
      <VendorMenu locationPath={locationPathOne} />
    ) : (
      <DesignerMenu locationPath={locationPathOne} />
    );
  };

  useEffect(() => {
    if (dataProfile && isLogged) {
      if (!qbSession) {
        console.log('QB init...');
        // Initialize QuickBlox SDK
        QB.init(
          process.env.REACT_APP_QB_APPLICATION_ID,
          process.env.REACT_APP_QB_AUTH_KEY,
          process.env.REACT_APP_QB_AUTH_SECRET,
          process.env.REACT_APP_QB_ACCOUNT_KEY
        );

        // Create Session to QuickBlox
        if (dataProfile?.id !== undefined) {
          QB.createSession(
            {
              login: `${process.env.REACT_APP_QB_MPREFIX}${dataProfile?.id}`,
              password: '12345678Ks@',
            },
            function (error, result) {
              // Sukses Create session
              if (error === null) {
                console.log('.. sukses');
                dispatch(changeQbSession(result));
                fetchDialogs();
                conectChatting();
              }
            }
          );
        }
      }
    }
  }, [dataProfile, isLogged, qbSession]);

  useEffect(() => {
    if (qbNewMessage) {
      if (locationPathOne !== 'messages') {
        let unread = qbUnread;
        ++unread;
        console.log('unread:', unread);
        dispatch(changeQbUnread(unread));
      }
    }
  }, [qbNewMessage]);

  useEffect(() => {
    console.log('use effect props.qbUnread:', qbUnread);
  }, [qbUnread]);

  useEffect(() => {
    if (!isLogged) {
      return;
    }

    // Foreground message
    const subscribe = onMessageListener().then((payload) => {
      console.log('FCM Payload:', payload);
      console.log('currentPageType:', currentPageType);
      setTimeout(() => {
        getNotificationList();
      }, 1000);
    });
    subscribe.catch((err) => console.log('FCM failed: ', err));

    // Background message
    const broadcast = new BroadcastChannel('background-message');
    const onBroadcastMessage = (event) => {
      console.log('message from service-worker:', event.data);
      console.log('currentPageType:', currentPageType);
      getNotificationList();
    };
    broadcast.addEventListener('message', onBroadcastMessage);
    return () => {
      broadcast.removeEventListener('message', onBroadcastMessage);
      broadcast.close();
    };
  }, [isLogged, mode]);

  useEffect(function firstLoad() {
    initialize();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 960) {
      setToggleSidebar(false);
      return;
    }
    setToggleSidebar(true);
  }, []);

  useEffect(() => {
    if (dataProfile) {
      if (dataProfile?.is_complete_profile === false) {
        navigate('/fill-profile-form');
        return;
      }
      if (dataProfile?.status === 'APPROVED') {
        if (dataProfile?.merchant_type === 'DESIGNER') {
          changeCurrentPageType('designer');
          if (location.pathname === '/' || location.pathname === '/caution') {
            navigate('/');
          }
        }
        return;
      }
      navigate('/caution');
    }
  }, [dataProfile]);

  if (isLogged) {
    return (
      <>
        <div
          style={
            loadingGeneral === false
              ? { display: 'block' }
              : { display: 'none' }
          }
        >
          <div
            className={`menubar-enabled wrapper-layout${
              toggleSidebar ? '' : ' menubar-collapsed'
            }`}
          >
            <AppMobileMenu menu={menu} />

            <div className="wrapper px-4">
              <AppHeader
                changeCurrentPageType={changeCurrentPageType}
                dataNotification={dataNotification}
                dataProfile={dataProfile}
                handleClickNotifItem={handleClickNotifItem}
                handleLogout={handleLogout}
                mode={mode}
                qbUnread={qbUnread}
              />

              <Outlet />

              <AppSidebar
                closeIcon={CloseIcon}
                handleToggleSidebar={() => setToggleSidebar(!toggleSidebar)}
                logo={Logo}
                menu={menu}
                toggleSidebar={toggleSidebar}
              />
            </div>
          </div>
        </div>
        <ScrollToTop />
      </>
    );
  }
};

export default Layout;
